﻿window.cObjetHebergementTarifDetailMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Tarif"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau tarif"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data == 'undefined' && objet.data == null) { txt = "Tarif" }
        else {
            txt = objet.data.nom
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-money-bill-transfer'></i>");
    }

    this.mGetPrixFromDate = function (dat) {
        //if (dat.getMonth() == 4 && dat.getDate() == 8) debugger;
        if (gestionDateNuite.isTarifNuitWeekEndVacances(dat) && objet.data.prix_ttc_we_vacances != 0) { return objet.data.prix_ttc_we_vacances }
        else if (gestionDateNuite.isTarifNuitWeekEnd(dat) && objet.data.prix_ttc_we != 0) { return objet.data.prix_ttc_we }
        else if (gestionDateNuite.isTarifNuitVacances(dat) && objet.data.prix_ttc_vacances != 0) { return objet.data.prix_ttc_vacances }
        else { return objet.data.prix_ttc }
    }

}